import { STANDARD_GRAVITY } from '@rcs/domain';

/**
 * 物理シミュレーションの既定値（docs/physics/physics-model.md 12 章）。
 * いずれも SI 単位。
 */

/** 既定の固定タイムステップ [s]（60 Hz / 120 Hz 表示の整数倍）。 */
export const DEFAULT_TIME_STEP = 1 / 240;

/** 結果フレームを記録する間隔（ステップ数）。1/240 s × 4 = 60 Hz。 */
export const DEFAULT_OUTPUT_INTERVAL_STEPS = 4;

/** 地球の重力加速度の既定値 [m/s²]。 */
export const EARTH_GRAVITY = STANDARD_GRAVITY;

/** 海面・15 °C の空気密度 [kg/m³]（国際標準大気）。 */
export const SEA_LEVEL_AIR_DENSITY = 1.225;

/** 静止判定に使う速度のしきい値 [m/s]。 */
export const REST_SPEED_EPSILON = 1e-3;

/** 最大シミュレーション時間の既定値 [s]。 */
export const DEFAULT_MAX_SIMULATION_TIME = 600;
